import { render, staticRenderFns } from "./ListBlockchainVersionView.vue?vue&type=template&id=5247f168"
import script from "./ListBlockchainVersionView.vue?vue&type=script&lang=ts"
export * from "./ListBlockchainVersionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports